export const ReportTabsConstants = {
  // ExternalFactor: { name: "External Factor", field: "ExternalFactor" },
  // InternalFactor: { name: "Internal Factor", field: "InternalFactor" },
  Stratergies: { name: "Report", field: "Report", type: "summernote" },
  //   Response: { name: "Discussion", field: "Discussion" },
};

export const ReportTabsArray = () => {
  var reportTabs = [];
  for (var key in ReportTabsConstants) {
    var tab = {
      name: ReportTabsConstants[key].name,
      field: ReportTabsConstants[key].field,
      type: ReportTabsConstants[key].type,
    };

    reportTabs.push(tab);
  }

  return reportTabs;
};
